import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { useAnimateLottie } from '../../hooks/useAnimateLottie'
import { useLazyLottieSource } from '../../hooks/useLazyLottieSource'
import { tID } from '../../utils/utils'

export interface OrbLottieProps {
  size?: number
  loop?: boolean
  loadingPulseOrb?: boolean
  marginBottom?: string
}

const OrbContainer = styled.View<{ size: number; offset: number; marginBottom?: string }>(
  ({ size, offset, marginBottom }) => ({
    marginTop: `-${offset}px`,
    marginLeft: `-${offset}px`,
    marginRight: `-${offset}px`,
    marginBottom: marginBottom ?? `-${offset}px`,
    width: `${size}px`,
    height: `${size}px`,
  }),
)

export const OrbLottie: FunctionComponent<OrbLottieProps> = ({
  size = 284,
  loop = true,
  loadingPulseOrb = false,
  marginBottom,
}) => {
  const { AnimationView } = useAnimateLottie()
  const adjustedSize = size * 1.23 // Size adjusted to account for the blur effect that overflows the view box
  const offset = adjustedSize * 0.1
  const animationData = useLazyLottieSource(
    () =>
      loadingPulseOrb
        ? import('../../assets/lottie/loading-pulse-orb.json')
        : import('../../assets/lottie/load-in-orb.json'),
    [loadingPulseOrb],
  )

  return (
    <OrbContainer
      size={adjustedSize}
      offset={offset}
      marginBottom={marginBottom}
      testID={tID('OrbLottie')}
      accessible={false}
      importantForAccessibility='no-hide-descendants'
    >
      {animationData && (
        <AnimationView
          source={animationData}
          loop={loop}
          autoPlay={true}
          style={{ height: adjustedSize, width: adjustedSize }}
        />
      )}
    </OrbContainer>
  )
}
